import { render, staticRenderFns } from "./SidebarContainer.vue?vue&type=template&id=002d2d57&"
import script from "./SidebarContainer.vue?vue&type=script&lang=js&"
export * from "./SidebarContainer.vue?vue&type=script&lang=js&"
import style0 from "./SidebarContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports